"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("@hotmart/cosmos/dist/form/form.css");
require("@hotmart/cosmos/dist/form/input-custom.css");
require("@hotmart/cosmos/dist/form/input-switch.css");
const Switch = ({ id, children, isChecked = false, 'data-test': dataTest, className, onChange }) => {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)('hot-form hot-form--custom hot-form--switch', className), children: [(0, jsx_runtime_1.jsx)("input", { type: "checkbox", role: "switch", id: id, className: "hot-form__input", checked: isChecked, "data-test": dataTest, onChange: onChange }), (0, jsx_runtime_1.jsx)("label", { className: "hot-form__label _my-0", htmlFor: id, children: children })] }));
};
exports.default = Switch;
